import { log } from "handlebars";
import { SearchResult, NoResults } from "./template";

/**
 * Default config that we control the ARIA attributes with
 */
export default class FunnelbackSearch {
  constructor(el) {
    this.root = el;
    this.elements = {
      container: el.querySelector(".search-results__container"),
      containerResponse: el.querySelector(
        ".search-results__container--response"
      ),
      containerMessage: el.querySelector(".search-results__container--message"),
      searchInput: el.querySelector(".form__search-input"),
      searchResults: el.querySelector(".search-results__listing"),
      noResults: el.querySelector(".search-results__no-results"),
      popularSearches: el.querySelector(".popular-searches"),
    };
    this.fetching;
    this.elements.searchInput.addEventListener("input", (e) =>
      this.onChange(e)
    );
  }

  /**
   * Fetch funnelback search results
   */
  async fetchResult(query) {
    // Check if current domain includes www prefix
    const currentDomain = window.location.hostname;
    const hasWww = currentDomain.startsWith('www.');
    
    // Construct URL based on whether current domain has www prefix
    const baseUrl = hasWww 
      ? 'https://www.seniorroadusers.vic.gov.au/_designs/funnelback/search'
      : 'https://seniorroadusers.vic.gov.au/_designs/funnelback/search';
    
    const url = `${baseUrl}?query=${query}`;
    const response = await fetch(url);
    return await response.json();
  }

  /**
   * Response function
   */

  response(data) {
    const results = data.results;
    let content;
    if (results) {
      content = SearchResult(results);
      this.elements.containerMessage.innerHTML = "";
      this.elements.containerResponse.innerHTML = content;
    } else {
      content = NoResults(data?.currated);
      this.elements.containerMessage.innerHTML = content;
      this.elements.containerResponse.innerHTML = "";
    }
  }

  /**
   * Type event on input
   */
  onChange(e) {
    const query = e.target.value;

    // Clear any existing timeout to cancel the previous fetch delay
    if (this.fetching) {
      clearTimeout(this.fetching);
    }

    // Check if the input value length is greater than 2 characters
    if (query.length > 2) {
      // Set a new timeout to fetch results after 2 seconds
      this.fetching = setTimeout(() => {
        // Fetch results
        return this.fetchResult(query).then((data) => {
          return this.response(data);
        });
      }, 2000);
    }
  }
}
